import { connect } from 'react-redux';
import { appModalClose, appModalOpen, projectsCreate, projectSetSystem, systemsCalculateBuffer, systemsDetermine } from 'actions';
import View from './';

const mapStateToProps = state => ({
  advisory: state.advisory,
  intl: state.intl,
  systems: state.systems,
});
const mapDispatchToProps = (dispatch) => {
  return {
    appModalClose(data) {
      return dispatch(appModalClose(data));
    },
    appModalOpen(data) {
      return dispatch(appModalOpen(data));
    },
    projectsCreate(data) {
      return dispatch(projectsCreate(data));
    },
    projectSetSystem(data) {
      return dispatch(projectSetSystem(data));
    },
    systemsDetermine(data) {
      return dispatch(systemsDetermine(data));
    },
    systemsCalculateBuffer(data) {
      return dispatch(systemsCalculateBuffer(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/advisory-tool/result/container.js